import {useTranslation} from "react-i18next";
import ApiService from "../../core/service/api-service";
import {Select} from "antd";
import {useEffect, useState} from "react";
import {useUser} from "../../core/context/UserContext";

/**
 * restrictToOwnPermissions: rol ATAMA ekranlarında açılır. Rolü atamak, o rolün bütün izinlerini
 * vermek demektir; kimse kendisinde olmayan bir izni veremeyeceği için böyle roller seçilemez
 * (sunucu da reddeder). keepPermissionIds, düzenlenen kullanıcıda ZATEN duran izinlerdir: onları
 * içeren rol seçilebilir kalır, yoksa yönetici kullanıcının mevcut rolüne bile geri dönemezdi.
 */
export default function RoleSelectBox({onRoleChange, restrictToOwnPermissions = false, keepPermissionIds = [], ...props})
{
    const {t} = useTranslation();
    const {ownsPermission, isSuperAdmin} = useUser();

    const [roles, setRoles] = useState([])

    const isAssignable = (role) => {
        if(!restrictToOwnPermissions || isSuperAdmin())
            return true

        return (role.permissionIdList || [])
            .every(p => ownsPermission(p) || keepPermissionIds.includes(p))
    }

    const getRoles = async () =>
    {
        const response = await ApiService.Role.GetList();
        if (response.success)
        {
            setRoles(response.data)
        }
    }

    useEffect(() => {
        getRoles()
    }, [])

    return (
        <>
            <Select
                mode="single"
                allowClear
                options={roles.map(r => ({...r, disabled: !isAssignable(r)}))}
                fieldNames={{
                    label: 'name',
                    value: 'id'
                }}
                {...props}
                onChange={(val, option) => {
                    props && props.onChange && props.onChange(val, option)
                    onRoleChange && onRoleChange(roles.find(x => x.id === val), roles)
                }}
            />
        </>
    )
}
